// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { asyncScheduler, Observable } from 'rxjs';
import { switchMap, throttleTime } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { deleteFavorites } from '../../apis/base';
import { deleteFavoritesActions } from '../actionCreators/deleteFavoritesActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: deleteFavoritesActions.success,
  failure: deleteFavoritesActions.failure
};

type RequestActionTypes = ActionType<
  typeof deleteFavoritesActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const deleteFavoritesEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(deleteFavoritesActions.request)
    ),
    throttleTime(1000, asyncScheduler, { leading: true, trailing: false }),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, condition, success } = action.payload;
      // send api promise
      return deleteFavorites(id, condition)
        .then((response: any) => {
          success();
          return deleteFavoritesActions.success('');
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return deleteFavoritesActions.failure({ error });
        })
    })
  );
};
